import "../../assets/css/--page-blog.css";
import BlogListing from "./BlogListing";
import BlogSlider from "./blogSliderSection";
import HeroHeader from "./heroHeader";



const Blogs = () => {
  return (
    <>
    <HeroHeader/>
      <BlogSlider />
      <BlogListing/>
      {/* <HomeBannerMobile /> */}
    </>
  );
};

export default Blogs;
